/**
 * vuex module for loading/restoring map state after the map/page are done loading
 * set the variables here and then switch to a new page, and the page can selectively set state
 * think of it kind of like a queue; the page will check any relevant variables here and process them as needed
 */

import * as actions from '@/constants/actions';
import * as mutations from '@/constants/mutations';

export default {
    state: {
        mapCenter: null, // { lat, lng }
        mapZoom: null, // Number
        mapFilterSettings: null, // Object
        selectFeature: null, // { id, type, coords, ... }
    },
    mutations: {
        [mutations.SET_LOADSTATE_MAP_CENTER](state, value = null) {
            state.mapCenter = value;
        },
        [mutations.SET_LOADSTATE_MAP_ZOOM](state, value = null) {
            state.mapZoom = value;
        },
        [mutations.SET_LOADSTATE_MAP_FILTER_SETTINGS](state, value = null) {
            state.mapFilterSettings = value;
        },
        [mutations.SET_LOADSTATE_SELECTED_FEATURE](state, value = null) {
            state.selectFeature = value;
        },
    },
    actions: {
        /**
         * reset any items in the loadState "queue"
         */
        [actions.RESET_LOADSTATE_ITEMS]({ commit }) {
            commit(mutations.SET_LOADSTATE_MAP_CENTER, null);
            commit(mutations.SET_LOADSTATE_MAP_ZOOM, null);
            commit(mutations.SET_LOADSTATE_MAP_FILTER_SETTINGS, null);
            commit(mutations.SET_LOADSTATE_SELECTED_FEATURE, null);
        },
        [actions.SET_LOADSTATE_MAP_CENTER]({ commit }, value = null) {
            commit(mutations.SET_LOADSTATE_MAP_CENTER, value);
        },
        [actions.SET_LOADSTATE_MAP_ZOOM]({ commit }, value = null) {
            commit(mutations.SET_LOADSTATE_MAP_ZOOM, value);
        },
        [actions.SET_LOADSTATE_MAP_FILTER_SETTINGS]({ commit }, value = null) {
            commit(mutations.SET_LOADSTATE_MAP_FILTER_SETTINGS, value);
        },
        [actions.SET_LOADSTATE_SELECTED_FEATURE]({ commit }, value = null) {
            commit(mutations.SET_LOADSTATE_SELECTED_FEATURE, value);
        },
    },
};



// WEBPACK FOOTER //
// ./src/store/modules/LoadStateModule.js